import { useState } from "react";

/**
 * State container for the Veriff Age Estimation fallback flow. Keeps the
 * age-estimation-specific state isolated from the base verification flow:
 * - `isFallbackOpened` — the fallback dialog visibility,
 * - `isFallbackInitPending` — the ID verification session is initialising,
 * - `authorizedMethodCode` — the method the user explicitly opted into, used to
 *   reveal the ID verification method once the user continues.
 */
export function useAgeEstimationFallback() {
  const [isFallbackOpened, setIsFallbackOpened] = useState(false);
  const [isFallbackInitPending, setIsFallbackInitPending] = useState(false);
  const [authorizedMethodCode, setAuthorizedMethodCode] = useState("");

  const openFallback = () => setIsFallbackOpened(true);

  const resetFallback = () => {
    setIsFallbackOpened(false);
    setIsFallbackInitPending(false);
    setAuthorizedMethodCode("");
  };

  return {
    isFallbackOpened,
    isFallbackInitPending,
    authorizedMethodCode,
    openFallback,
    resetFallback,
    setIsFallbackInitPending,
    setAuthorizedMethodCode,
  };
}
